<template>
  <modal
    transition="pop-out"
    name="attach-customer"
    :adaptive="true"
    :pivotY="0.5"
    :scrollable="true"
    :height="'auto'"
    :width="930">
    <div class="h-12 w-full border-b border-gray-200">
      <p class="px-6 py-2 text-gray-700">Attach Customer to Loyalty Level</p>
    </div>
    <div class="w-full p-6 mx-auto">
      <div class="mb-4 w-1/5">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Level
        </label>
        <el-select class="w-full" v-model="form.level" placeholder="Select Category">
          <el-option
            v-for="level in levels"
            :key="level.value"
            :label="level.label"
            :value="level">
          </el-option>
        </el-select>
        <p v-if="errors.includes('level')" class="text-red-500 text-xs italic">Please provide a loyalty level.</p>
      </div>
      <hr class="mt-4">
      <div class="mb-4 w-1/5">
        <label class="block text-gray-700 text-sm font-bold mb-2">
          Search for Customers
        </label>
        <input v-model="query" @input="filterCustomer" class="border w-full py-2 px-3 text-gray-700 leading-tight" type="text" placeholder=" Search for item">
      </div>
      <div
        v-loading="loading"
        element-loading-text="Loading..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-transfer
          style="width: 100%; display: inline-block"
          v-model="form.values"
          filterable
          :titles="['Source', 'Target']"
          :button-texts="['To left', 'To right']"
          :format="{
            noChecked: '${total}',
            hasChecked: '${checked}/${total}'
          }"
          @change="handleChange"
          :data="items">
          <span slot-scope="{ option }" class="text-xs">{{ option.label }}</span>
        </el-transfer>
        <p v-if="errors.includes('values')" class="text-red-500 text-xs italic">Please provide Products to attach</p>
      </div>
      <el-pagination
        class="mt-8 mb-4"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-size="pagination.perPage"
        :page-count="pagination.lastPage"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total">
      </el-pagination>
      <hr>
      <el-button class="mt-8" @click="submit" type="primary" :loading="creating">Attach Items to {{form.level ? form.level.label : 'Level'}}</el-button>
    </div>
  </modal>

</template>

<script>
export default {
  name: 'AttachCustomersToLevel',
  data() {
    return {
      errors: [],
      loading: false,
      creating: false,
      query: '',
      page: 1,
      limit: 200,
      form: {
        level: null,
        values: [],
      },
    };
  },
  computed: {
    levels() {
      return this.$store.state.LoyaltyModule.levels.map(item => ({
        value: item.id,
        label: item.name,
      }));
    },
    items: {
      get() {
        return this.$store.state.CustomerModule.customers.map(item => ({
          key: item.id,
          label: `${item.first_name} ${item.last_name}`,
          disabled: false,
        }));
      },

      set(value) {},
    },

    pagination() {
      return this.$store.state.CustomerModule.pagination;
    },
  },
  methods: {
    async handleSizeChange(args) {
      this.limit = args;
      await this.fetchAllCustomers();
    },
    async handleCurrentChange(args) {
      this.page = args;
      await this.fetchAllCustomers();
    },
    async filterCustomer() {
      if (this.query.length === 0 || this.query.length > 3) {
        await this.fetchAllCustomers();
      }
    },
    async fetchAllCustomers() {
      this.loading = true;
      try {
        await this.$store.dispatch('CustomerModule/fetchAllCustomers', {
          page: this.page,
          limit: this.limit,
          query: this.query,
        });
      } catch (e) {
        // Handle This TODO
      }

      this.loading = false;
    },
    handleChange() {},
    async submit() {
      this.errors = this.validation(this.form);

      if (this.errors.length === 0) {
        this.creating = true;

        try {
          await this.$store.dispatch('LoyaltyModule/createLoyaltyCustomer', {
            payload: {
              loyalty_level_id: this.form.level.value,
              user_ids: this.form.values,
            },
          });
          this.$modal.hide('attach-customer');
          this.$notify.success({
            title: 'Success',
            message: 'New Level Customers added',
          });

          this.creating = true;
        } catch (e) {
          this.creating = true;

          if (e.errors) {
            this.$notify.error({
              title: 'Error',
              message: e.errors[0],
            });
          } else {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong',
            });
          }
        }

        this.creating = true;
      }
    },
  },

  async mounted() {
    await this.fetchAllCustomers();
  },
};
</script>

<style lang="scss">
.v--modal {
  .el-transfer {
    .el-transfer-panel {
      text-align: left;
      width: 300px !important;
      height: 400px;

      .el-transfer-panel__body {
        height: 300px;
        .el-transfer-panel__list.is-filterable {
          height: 100%;
        }
      }
    }

    .transfer-footer {
      margin-left: 20px;
      padding: 6px 5px;
    }
  }
}

</style>

